import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import PanThumb from '@/components/PanThumb/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.emptyGif = 'https://wpimg.wallstcn.com/0e03b7da-db9e-4819-ba10-9016ddfdaed3';
  }
  get name() {
    return AdminModule.name;
  }
  get avatar() {
    return AdminModule.avatar;
  }
  get roles() {
    return AdminModule.roles;
  }
};
default_1 = __decorate([Component({
  name: 'DashboardExecutive',
  components: {
    PanThumb
  }
})], default_1);
export default default_1;